import { Form, Formik } from "formik";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  currentTenant,
  financialyearend,
  financialyearstart,
  thousandsdisplay,
  userid,
} from "../../Common/Credentials";
import { spin } from "../../Common/NewLoader";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import {NumericFormat} from "react-number-format";
import MUIDataTable from "mui-datatables";
import SalesServices from "../SalesServices";

import moment from "moment";

import "date-fns";
import Grid from "@mui/material/Grid";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";import { Button } from "react-bootstrap";
import { TextField, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material";

import UpArrow from "../../images/Icons/up-arrow.png";

const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});
class SalesReturnsReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportsdata: [],
      filterOptions: [
        { id: 0, name: "Overall" },
        { id: 1, name: "Product" },
        { id: 2, name: "Customer" },
      ],
      overall: true,
      pro: false,
      cust: false,
      toppro: false,
      topcust: false,
      filterdata: [],
      products: "",
      customers: "",
      productslist: [],
      custbyproducts: [],
      customerslist: [],
      productsbycust: [],
      topproducts: [],
      topcustomers: [],
      loading: false,
      selected: 0,
      fromdate: financialyearstart,
      todate: new Date(),
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.clearfilter = this.clearfilter.bind(this);
  }

  onChange(option) {
    this.setState({ selected: option.id });
  }

  handleFromDateChange = (date) => {
    this.setState({ fromdate: date });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  clearfilter() {
    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess:""
    }

    SalesServices.getSalesReturnsReport(datadao)
      .then((response) => {
        this.setState(
          {
            reportsdata: response.data,
            filterdata: response.data,
            loading: false,
          },
          () => {
            this.Productdata();
            this.Customerdata();
          }
        );
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  onSubmit() {
    let datadao = {
      tenantid: currentTenant,
      startdate: this.state.fromdate,
      enddate: this.state.todate,
      userid: userid,
      dataaccess:""
    }

    SalesServices.getSalesReturnsReport(datadao)
      .then((response) => {
        this.setState(
          {
            reportsdata: response.data,
            filterdata: response.data,
            loading: false,
          },
          () => {
            this.Productdata();
            this.Customerdata();
          }
        );
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  // handlefilter(value,values){
  // }
  // handleOverallChange=()=>{
  //   this.setState({overall:true,pro:false,cust:false,toppro:false,topcust:false,filterdata:this.state.reportsdata})
  // }
  // handleProductChange=()=>{
  //   this.setState({pro:true,cust:false,toppro:false,topcust:false,overall:false})
  //   // this.Productdata()
  // }
  // handleCustomerChange=()=>{
  //   this.setState({cust:true,pro:false,toppro:false,topcust:false,overall:false})
  //   // this.Customerdata()
  // }
  // handleTopProductsChange=()=>{
  //   this.setState({toppro:true,pro:false,cust:false,topcust:false,overall:false})
  // }
  // handleTopCustomerChange=()=>{
  //   this.setState({topcust:true,pro:false,cust:false,toppro:false,overall:false})
  // }

  Productdata = () => {
    this.setState({ productslist: [], custbyproducts: [] }, () => {
      // Sorting Sales Products
      const products = this.state.filterdata.reduce(
        (
          item,
          {
            itemname,
            itemid,
            quantity,
            totalprice,
            totalpricewtax,
            createdAt,
            customer,
            custid,
          }
        ) => {
          if (!item[itemname]) item[itemname] = [];
          item[itemname].push({
            itemid: itemid,
            itemname: itemname,
            quantity: quantity,
            totalprice: totalprice,
            totalpricewtax: totalpricewtax,
            createdAt: createdAt,
            customer: customer,
            custid: custid,
          });
          return item;
        },
        {}
      );
      this.setState({ products: products });
      // End of Sorting Products

      // Calcuating total sales by products
      Object.entries(products).forEach(([key, value]) => {
        let a = {
          itemname: key,
          itemid: value.map((e) => e.itemid)[0],
          quantity: value.reduce((a, v) => (a = a + v.quantity), 0),
          totalprice: value.reduce((a, v) => (a = a + v.totalprice), 0),
          totalpricewtax: value.reduce((a, v) => (a = a + v.totalpricewtax), 0),
        };
        this.state.productslist.push(a);
      });
      // End of Calcuating total sales products

      // Sorting item sales By customer
      Object.entries(products).forEach(([key, value]) => {
        const custbyproducts = value.reduce(
          (
            cust,
            {
              itemname,
              itemid,
              quantity,
              totalprice,
              totalpricewtax,
              createdAt,
              customer,
              custid,
            }
          ) => {
            if (!cust[custid]) cust[custid] = [];
            cust[custid].push({
              itemid: itemid,
              itemname: itemname,
              quantity: quantity,
              totalprice: totalprice,
              totalpricewtax: totalpricewtax,
              createdAt: createdAt,
              customer: customer,
              custid: custid,
            });
            return cust;
          },
          {}
        );
        Object.entries(custbyproducts).forEach(([key, value]) => {
          let a = {
            custid: key,
            customer: value.map((e) => e.customer)[0],
            itemid: value.map((e) => e.itemid)[0],
            itemname: value.map((e) => e.itemname)[0],
            quantity: value.reduce((a, v) => (a = a + v.quantity), 0),
            totalprice: value.reduce((a, v) => (a = a + v.totalprice), 0),
            totalpricewtax: value.reduce(
              (a, v) => (a = a + v.totalpricewtax),
              0
            ),
          };
          this.state.custbyproducts.push(a);
        });
      });
      //  End of Sorting item sales By customer

      // Top 10 Products

      const topproducts = []
        .concat(this.state.productslist)
        .sort((a, b) => (a.totalpricewtax < b.totalpricewtax ? 1 : -1));

      this.setState({ topproducts: topproducts.slice(0, 10) });
    });
  };

  Customerdata = () => {
    this.setState({ customerslist: [], productsbycust: [] }, () => {
      const customers = this.state.filterdata.reduce(
        (
          cust,
          {
            itemname,
            itemid,
            quantity,
            totalprice,
            totalpricewtax,
            createdAt,
            customer,
            custid,
          }
        ) => {
          if (!cust[customer]) cust[customer] = [];
          cust[customer].push({
            itemid: itemid,
            itemname: itemname,
            quantity: quantity,
            totalprice: totalprice,
            totalpricewtax: totalpricewtax,
            createdAt: createdAt,
            customer: customer,
            custid: custid,
          });
          return cust;
        },
        {}
      );
      this.setState({ customers: customers });

      Object.entries(customers).forEach(([key, value]) => {
        let a = {
          customer: key,
          custid: value.map((e) => e.custid)[0],
          quantity: value.reduce((a, v) => (a = a + v.quantity), 0),
          totalprice: value.reduce((a, v) => (a = a + v.totalprice), 0),
          totalpricewtax: value.reduce((a, v) => (a = a + v.totalpricewtax), 0),
        };
        this.state.customerslist.push(a);
      });

      Object.entries(customers).forEach(([key, value]) => {
        const productsbycust = value.reduce(
          (
            item,
            {
              itemname,
              itemid,
              quantity,
              totalprice,
              totalpricewtax,
              createdAt,
              customer,
              custid,
            }
          ) => {
            if (!item[itemid]) item[itemid] = [];
            item[itemid].push({
              itemid: itemid,
              itemname: itemname,
              quantity: quantity,
              totalprice: totalprice,
              totalpricewtax: totalpricewtax,
              createdAt: createdAt,
              customer: customer,
              custid: custid,
            });
            return item;
          },
          {}
        );
        Object.entries(productsbycust).forEach(([key, value]) => {
          let a = {
            itemid: key,
            customer: value.map((e) => e.customer)[0],
            custid: value.map((e) => e.custid)[0],
            itemname: value.map((e) => e.itemname)[0],
            quantity: value.reduce((a, v) => (a = a + v.quantity), 0),
            totalprice: value.reduce((a, v) => (a = a + v.totalprice), 0),
            totalpricewtax: value.reduce(
              (a, v) => (a = a + v.totalpricewtax),
              0
            ),
          };
          this.state.productsbycust.push(a);
        });
      });

      // Top 10 Customers
      const topcustomers = []
        .concat(this.state.customerslist)
        .sort((a, b) => (a.totalpricewtax < b.totalpricewtax ? 1 : -1));

      this.setState({ topcustomers: topcustomers.slice(0, 10) });
    });
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });

    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess:""
    }

    SalesServices.getSalesReturnsReport(datadao)
      .then((response) => {
        this.setState(
          {
            reportsdata: response.data,
            filterdata: response.data,
            loading: false,
          },
          () => {
            this.Productdata();
            this.Customerdata();
          }
        );
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

  }

  validate(values) {
    let errors = {};
    // alert(moment(newthis.state.to).diff(this.state.from,'days'));
    // if (moment(this.state.to).diff(this.state.from,'days')<0 ) {
    //   alert("To date must be greater than From date");
    //   errors.to = "To date must be greater than From date";
    // }
    if (this.state.from === null) {
      alert("Please Select From date");
      errors.from = "Please Select From date";
    }
    if (this.state.to === null) {
      alert("Please Select to date");
      errors.to = "Please Select to date";
    }
    return errors;
  }
  render() {
    const columns = [
      // {
      //   name: "itemid",
      //   label: "Item Id",
      //   options: { filter: false, sort: true,sortOrder : 'asc' },
      // },
      {
        name: "itemname",
        label: "Item Name",
        options: { filter: true, sort: true, sortOrder: "asc" },
      },
      {
        name: "customer",
        label: "Customer",
        options: { filter: true, sort: true },
      },
      {
        name: "quantity",
        label: "Quantity",
        options: { filter: false, sort: true },
      },
      {
        name: "price",
        label: "Unit Cost",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "totalprice",
        label: "Total",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "tax",
        label: "Tax",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <>{value} %</>;
          },
        },
      },
      {
        name: "totalpricewtax",
        label: "Total",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "createdAt",
        label: "Date",
        options: {
          filter: false,
          sort: true,
          sortOrder: "asc",
          customBodyRender: (tableMeta) => {
            return moment(tableMeta).format("DD-MM-YYYY hh:mm");
          },
        },
      },
    ];

    const productscolumns = [
      {
        name: "itemname",
        label: "Item Name",
        options: {
          filter: true,
          sort: true,
          sortOrder: "asc",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <Link
                  as="button"
                  data-tip
                  data-for="view details"
                  className="text-info"
                  to={{pathname: "/salesreturnsreportdetails"}}
                    state={ {
                      data: this.state.custbyproducts.filter(
                        (e) => e.itemname === value
                      ),
                      data2: this.state.products[value],
                      item: value,
                      pagename: "Sales Returns by Products",
                  }}
                >
                  {value}
                </Link>
                {/* //<Tooltip id="view details" place="top" effect="solid">
                  View Details
                </Tooltip> */}
              </>
            );
          },
        },
      },
      // {
      //   name: "itemid",
      //   label: "Item Id",
      //   options: { filter: false, sort: true },
      // },
      {
        name: "quantity",
        label: "Quantity",
        options: { filter: false, sort: true },
      },
      {
        name: "totalprice",
        label: "Total Price",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "totalpricewtax",
        label: "Total(Inc.Tax)",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
    ];

    const customercolumns = [
      {
        name: "customer",
        label: "Customer",
        options: {
          filter: false,
          sort: true,
          sortOrder: "asc",
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <Link
                  as="button"
                  data-tip
                  data-for="view details"
                  className="text-info"
                  to={{pathname: "/salesreturnsreportdetails"}}
                    state={{
                      data: this.state.productsbycust.filter(
                        (e) => e.customer === value
                      ),
                      data2: this.state.customers[value],
                      item: value,
                      pagename: "Sales Returns by Customer"
                  }}
                >
                  {value}
                </Link>
                {/* //<Tooltip id="view details" place="top" effect="solid">
                  View Details
                </Tooltip> */}
              </>
            );
          },
        },
      },
      // {
      //   name: "custid",
      //   label: "Customer Id",
      //   options: { filter: false, sort: true },
      // },
      {
        name: "quantity",
        label: "Quantity",
        options: { filter: true, sort: true },
      },
      {
        name: "totalprice",
        label: "Total Price",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
      {
        name: "totalpricewtax",
        label: "Total(Inc.Tax)",
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <NumericFormat
                className="pr-3"
                displayType={"text"}
                value={value}
                decimalScale={2}
                fixedDecimalScale={true}
                disabled={true}
                thousandSeparator={true}
                thousandsGroupStyle={thousandsdisplay}
              ></NumericFormat>
            );
          },
          setCellProps: (value) => ({ style: { textAlign: "right" } }),
        },
      },
    ];
    const options = {
      filterType: "checkbox",
      selectableRows: "none",
    };
    return (
      <div>
         <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="card">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item text-secondary">
                <Link to="/sales">Home</Link>
              </li>
              <li className="breadcrumb-item active">Sales Returns Report</li>
            </ol>

            <div className="card-body">
              <div>
                {this.state.loading === true ? (
                  <div className="text-center">{spin}</div>
                ) : (
                  <Formik
                    initialValues={{
                      from: this.state.fromdate,
                      to: this.state.todate,
                    }}
                    onSubmit={this.onSubmit}
                    validateOnChange={false}
                    validate={this.validate}
                    enableReinitialize={true}
                  >
                    {({ setFieldValue, values }) => (
                      <Form autoComplete="off">
                        <div className="form-row g-0">
                          <fieldset>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Grid container justify="space-around">
                                <DatePicker
                                  variant="inline"
                                  id="date-picker-dialog"
                                  label="From Date"
                                  name="from"
                                  format="dd/MM/yyyy"
                                  maxDate={new Date()}
                                  value={this.state.fromdate}
                                  onChange={this.handleFromDateChange}
                                  renderInput={(params) => <TextField {...params} variant="standard"/>}
                                  autoOk={true}
                                />
                              </Grid>
                            </LocalizationProvider>
                          </fieldset>

                          <fieldset style={{ marginLeft: "30px" }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <Grid container justify="space-around">
                                <DatePicker
                                  variant="inline"
                                  id="date-picker-dialog"
                                  label="To Date"
                                  name="to"
                                  format="dd/MM/yyyy"
                                  maxDate={new Date()}
                                  value={this.state.todate}
                                  onChange={this.handleToDateChange}
                                  renderInput={(params) => <TextField {...params} variant="standard"/>}
                                  autoOk={true}
                                />
                              </Grid>
                            </LocalizationProvider>
                          </fieldset>
                          <fieldset className="form-group col-md-1">
                            <button
                              className="btn btn-sm hovbuttonColour mt-3"
                              type="submit"
                            >
                              <i className="fas fa-filter" />
                            </button>
                          </fieldset>
                          {this.state.todate !== null ? (
                            <fieldset className="form-group col-md-2">
                              <Button
                                className="btn btn-sm bg-white shadow-sm mt-3"
                                onClick={this.clearfilter}
                              >
                                {" "}
                                <b style={{ color: "#FA5733" }}> X</b> Clear
                                Filter
                              </Button>
                            </fieldset>
                          ) : (
                            ""
                          )}
                          <div className="form-group col-md-12 text-sm" />

                          <div className="d-flex gap-2 m-2">
                            {this.state.filterOptions.map((option) => (
                              <fieldset
                                      key={option.id}
                                className={`tab-button mr-2 ${this.state.selected === option.id ? "active-tab" : "inactive-tab"
                                  }`}
                                onClick={() => this.onChange(option)}
                              >
                                {option.name}
                                <img
                                  src={UpArrow}
                                  alt="Up Arrow"
                                  style={{
                                    marginLeft: "4px",
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    padding: "4px",
                                    transform: "rotate(30deg)",
                                  }}
                                />
                              </fieldset>
                            ))}
                                  </div>

                        </div>
                        {this.state.selected === 0 ? (
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm"
                              title={"Sales Returns Report(OverAll)"}
                              data={this.state.filterdata}
                              columns={columns}
                              options={options}
                            />
                          </ThemeProvider>
                        ) : (
                          ""
                        )}

                        {this.state.selected === 1 ? (
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm"
                              title={"Sales Returns Report(Products)"}
                              data={this.state.productslist}
                              columns={productscolumns}
                              options={options}
                            />
                          </ThemeProvider>
                        ) : (
                          ""
                        )}

                        {this.state.selected === 2 ? (
                          <ThemeProvider theme={theme}>
                            <MUIDataTable
                              className="table-sm"
                              title={"Sales Returns Report(Customers)"}
                              data={this.state.customerslist}
                              columns={customercolumns}
                              options={options}
                            />
                          </ThemeProvider>
                        ) : (
                          ""
                        )}
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(SalesReturnsReport);
